<form [formGroup]="analysisFormGroup_AP" (ngSubmit)="onSubmit(analysisFormGroup_AP.value)" novalidate>
    <div class="row">
        <div class="col-md-9 my-3">
            <mat-form-field appearance="fill">
                <mat-label>Regression Type</mat-label>
                <mat-select formControlName="analysisSubtype">
                    <mat-option value="logistic">4PL + 5PL</mat-option>
                    <mat-option value="mass_spec">Linear + Quadratic</mat-option>
                </mat-select>
            </mat-form-field>
         </div>
    </div>
    <div formArrayName="analyteNames">
        <div class="row" *ngFor="let analyte of analyteNames.controls; let i=index">
            <div class="col-md-9 my-3">
                <mat-form-field appearance="fill">
                    <input matInput placeholder="Analyte Name" type="text" [formControlName]="i" required
                       >
                </mat-form-field>
                <ng-container
                *ngIf="analyteNames.controls[i]?.invalid && (analyteNames.controls[i]?.dirty || analyteNames.controls[i]?.touched)">
                    <span class="text-danger">Must be <strong>Alphanumeric</strong></span>
                </ng-container>
            </div>
<!--                <div class="col-md-3" *ngIf="i>0">-->
<!--                    <button class="btn btn-danger" type="button" (click)="removeAnalyte(i)">Remove-->
<!--                        Analyte</button>-->
<!--                </div>-->
        </div>
<!--            <div *ngIf="analyteNames.at(0).value.toString().length > 2">-->
<!--                <button mat-raised-button type="button" (click)="addAnalyte()">Add Analyte</button>-->
<!--            </div>-->
    </div>
    <div class="row">
        <div class="col-md-9 my-3">
            <mat-form-field appearance="fill">
                <input matInput placeholder="Project Code" formControlName="projectCode" required
                    [ngClass]="{ 'is-invalid': formControls.projectCode.errors }">
                <mat-error *ngIf="analysisFormGroup_AP.controls['projectCode'].errors"
                    class="invalid-feedback error">
                    <mat-hint
                        [hidden]="!analysisFormGroup_AP.controls['projectCode'].hasError('maxlength')"
                        align="end">Exceeds 50 character limit.</mat-hint>
                    <div *ngIf="analysisFormGroup_AP.controls['projectCode'].errors.pattern">Must be
                        <strong>Alphanumeric</strong>
                    </div>
                </mat-error>
            </mat-form-field>

        </div>
    </div>
    <button class="btn btn-primary m-1 my-5"
        color="primary" type="submit" [disabled]="!analysisFormGroup_AP.valid" matStepperNext>
        Submit
    </button>
</form>